/** Set when user already saw /payment/result for a txn — chat should not auto-open details. */
const STORAGE_KEY = 'cwy_payment_result_seen';

export function markPaymentResultSeen(transactionId: string | null | undefined): void {
  if (!transactionId) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, String(transactionId));
  } catch {
    // ignore quota / private mode
  }
}

/** Returns true if this txn already showed the result page; clears the flag when matched. */
export function consumePaymentResultSeen(transactionId: string | null | undefined): boolean {
  if (!transactionId) return false;
  try {
    const seen = sessionStorage.getItem(STORAGE_KEY);
    if (seen && seen === String(transactionId)) {
      sessionStorage.removeItem(STORAGE_KEY);
      return true;
    }
  } catch {
    // ignore
  }
  return false;
}
